import { Component, Input, ViewChild } from '@angular/core';
import { CdkTreeNode, FlatTreeControl, TreeControl } from '@angular/cdk/tree';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { map, switchMap, filter, forkJoin } from 'rxjs';
import { ProductsService } from 'src/app/services/products.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MasterDataService } from 'src/app/services/master-data.service';
import { HttpClient } from '@angular/common/http';
import { OemService } from 'src/app/services/oem/oem.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SpecificationService } from 'src/app/services/shared/product-settings/specification.service';

@Component({
  selector: 'app-products-search-landing-page',
  templateUrl: './products-search-landing-page.component.html',
  styleUrls: ['./products-search-landing-page.component.scss']
})
export class ProductsSearchLandingPageComponent {

  filterColumns: string[] = ['Products', 'Region', 'Application', 'Shape', 'Size', 'Model', 'SampleType', 'LightSource', 'Configuration', 'IntensityAt1ms', 'Options'];
  category: any;
  products: any[] = [];
  breadcrumb: any;
  originalData: any[] = [];
  @Input() data: any;
  itemsPerPage = 12;
  showNoRecordsFounds: boolean = false;
  newData: any[] = [];
  contentItems = [

  ];
  totalProductCount: number = 0;
  productData: any = [];
  specificationsData?: any[];
  isViewAll: boolean = false;
  form: FormGroup = new FormGroup({});
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger })
  autoComplete!: MatAutocompleteTrigger;

  isPaginationDisabled: boolean = false;
  pageNumber: number = 0;
  pageSize: number = 12;
  pageNumberMXM: number = -1;
  zero: boolean = false;
  isSubcategories: boolean = false;
  productDetailsDto = {
    searchKeyword: '',
    country: '',
    state: '',
    city: '',
    zipcode: [],
    brandIds: [],
    categoryIds: [],
    specifications: [],
  }
  isMobileScreen: boolean = false;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    private productsService: ProductsService,
    private masterDataService: MasterDataService,
    private http: HttpClient,
    private oemService: OemService,
    private specificationService: SpecificationService,
  ) { }

  scrollEvent = (event: any): void => {
    if (this.autoComplete.panelOpen)
      this.autoComplete.closePanel();
  }

  executeGetRequestURL(url: string, params: any, type: string) {
    (this as any)[type] = [];
    this.masterDataService.executeGetRequestURL(url, params).subscribe(data => {
      if (data && data?.data && data.data.length > 0) {
        (this as any)[type] = data.data;
      }
    }, _error => {
    })
  }

  categoryId!: string;

  ngOnInit(): void {
    this.topOfPage();
    this.checkScreenSize();
    this.isViewAll = window.history.state.isViewAll;
    this.pageNumber = 0;
    this.pageNumberMXM = -1;
    this.zero = false;
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.productDetailsDto.searchKeyword = params.get('search') || '';
      const page = parseInt(params.get('page') || '1', 10);
      this.pageNumber = !isNaN(page) && page > 0 ? page - 1 : 0;
      this.getProductsBySearchKeyword();
    });
  }

  getProductsBySearchKeyword() {
    this.productsService.getAllProductsBySearch(this.pageNumber, this.pageSize, this.productDetailsDto).subscribe({
      next: (res) => {
        this.originalData = [...res?.data];
        this.products = res?.data?.map((product: any) => {
          let productSpecs: any[] = [];
          product.specifications.forEach((spec: any) => {
            if (spec.isRange === 'false') {
              productSpecs.push({
                name: spec.name,
                value: `${spec.fromValue ? spec.fromValue : ''} ${spec.fromUnit ? spec.fromUnit : ''}`
              });
            } else {
              productSpecs.push({
                name: spec.name,
                value: `${spec.fromValue ? spec.fromValue : ''} ${spec.fromUnit ? spec.fromUnit : ''} - ${spec.toValue ? spec.toValue : ''} ${spec.toUnit ? spec.toUnit : ''}`
              });
            }
          });

          return {
            id: product?.id,
            oemId: product?.oemId,
            productImage: product?.images?.[0],
            title: product?.name,
            subtitleImage: product?.logo,
            contentItems: productSpecs.sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
            hoverText: product?.description
          };
        });

        if(!this.originalData || this.originalData.length === 0) {
          this.pageNumberMXM = this.pageNumber-1;
          this.zero = true;
          this.pageNumber -= 1;
          this.showNoRecordsFounds = true;
          this.originalData = [];
          this.totalProductCount = 0;
        } else if(this.originalData && this.originalData.length < 10) {
          this.pageNumberMXM = this.pageNumber;
          this.totalProductCount = res.totalCount ? res.totalCount : 0;
          this.showNoRecordsFounds = false;
        } else {
          this.totalProductCount = res.totalCount ? res.totalCount : 0;
          this.showNoRecordsFounds = false;
        }
      },
      error: (error: any) => {
        this.showNoRecordsFounds = true;
        this.originalData = [];
        this.totalProductCount = 0;
      }
    });
  }



  getProductDetails(id: string) {
    return this.productsService.getProductDetails(id);
  }

  filteredData = this.products;

  paginatedItems: { catalog: string, title: string, type: string, }[] = [];

  onFilteredData(event: any): void {
    this.pageNumber = 0;
    this.pageNumberMXM = -1;
    this.productDetailsDto = { ...this.productDetailsDto, ...event };
    this.getProductsBySearchKeyword();
  }

  nextpage() {
    const isLastPage = this.getTotalPages() - this.pageNumber;

    if(isLastPage === 1) {
      this.isPaginationDisabled = true;
      return;
    } else {
      this.isPaginationDisabled = false;
    }
    this.pageNumber += 1;
    
    this.getProductsBySearchKeyword();
    this.getCurrentPageInfo(this.pageNumber);
    this.topOfPage();
  }

  prevpage() {
    this.pageNumber -= 1;
    this.getProductsBySearchKeyword();
    this.getCurrentPageInfo(this.pageNumber);
    this.topOfPage();
  }

  onAllProductsCount(event: any) {
    this.totalProductCount = event;
  }

  getTotalPages() {
    return Math.ceil(this.totalProductCount / this.pageSize);
  }

  showAllPaginationNumbers(): any[] {
    const totalPages = this.getTotalPages() ? this.getTotalPages() : 0;
    const currentPage = this.pageNumber;
    const pageNumbers: any[] = [];

    if (totalPages <= 1) return [0];

    pageNumbers.push(0);

    if (currentPage > 2) {
      pageNumbers.push('...');
    }

    for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages - 2, currentPage + 1); i++) {
      pageNumbers.push(i);
    }

    if (currentPage < totalPages - 3) {
      pageNumbers.push('...');
    }

    if (totalPages > 1) {
      pageNumbers.push(totalPages - 1);
    }

    return pageNumbers;
  }

  changePage(pageIndex: number): void {
    if (pageIndex < 0 || pageIndex >= this.getTotalPages()) {
      return;
    }
    this.pageNumber = pageIndex;
    this.getProductsBySearchKeyword();
    this.getCurrentPageInfo(this.pageNumber);
    this.topOfPage();
  }

  topOfPage(){
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
  }

  checkScreenSize() {
    const resizeWidth = window.innerWidth;
      if (resizeWidth <= 768) {
        this.isMobileScreen = true;
      } else {
        this.isMobileScreen = false;
      }
  }

  ngAfterViewInit() {
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  ngDestroy() {
    window.removeEventListener('resize', () => { });
  }

  getCurrentPageInfo(pageNumber: number) {
    this.router.navigate([], {
      queryParams: { page: pageNumber + 1 },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

}
